var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col justify-center items-center"},[_c('div',{style:(`${_vm.width};${_vm.height}`)},[_c('icon',{staticClass:"wfull",attrs:{"icon-name":"empty-box","size":"xs"}})],1),_c('p',[_vm._v("There are no folders created yet.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }